import api from '../../config/api';
import { getJsonResponse } from '../../utils/ApiUtils';
import Intervention, { AddInterventionOptions } from '../../interfaces/api/Intervention';
import Ticket from 'src/interfaces/api/Ticket';
import { CollectionResponse } from '../../interfaces/api/api';
import { Order } from '../../interfaces/Table';
import useAuth from './useAuth';

const useIntervention = () => {
  const { fetch } = useAuth();

  const get = async (id: string): Promise<Intervention> => {
    const { endpoint, ...options } = api.intervention.get(id);

    const response = await fetch(endpoint, options);

    try {
      return await getJsonResponse<Intervention>(response);
    } catch (e) {
      throw new Error(e.message);
    }
  };

  const remove = async (id: Intervention['id']): Promise<any> => {
    const { endpoint, ...options } = api.intervention.remove(id);

    const response = await fetch(endpoint, options);

    try {
      return await getJsonResponse(response);
    } catch (e) {
      throw new Error(e.message);
    }
  };

  const getAll = async (
    ticketId: Ticket['id'],
    page: number,
    limit: number,
    orderBy: keyof Intervention,
    order: Order
  ): Promise<CollectionResponse<Intervention>> => {
    const { endpoint, ...options } = api.intervention.getAll(ticketId, page, limit, orderBy, order);

    const response = await fetch(endpoint, options);

    try {
      return await getJsonResponse<CollectionResponse<Intervention>>(response);
    } catch (e) {
      throw new Error(e.message);
    }
  };

  const getTicketInterventions = async (ticketId: Ticket['id']): Promise<CollectionResponse<Intervention>> => {
    const { endpoint, ...options } = api.intervention.getTicketInterventions(ticketId);

    const response = await fetch(endpoint, options);

    try {
      return await getJsonResponse<CollectionResponse<Intervention>>(response);
    } catch (e) {
      throw new Error(e.message);
    }
  };

  const create = async (ticketId: string, interventionOptions: AddInterventionOptions): Promise<Intervention> => {
    const { endpoint, ...options } = api.intervention.create(ticketId, interventionOptions);

    const response = await fetch(endpoint, options);

    try {
      return await getJsonResponse<Intervention>(response);
    } catch (e) {
      throw new Error(e.message);
    }
  };

  return {
    remove,
    create,
    getAll,
    getTicketInterventions,
    get,
  };
};

export default useIntervention;
